var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGfxHacker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220.43 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3f3d56;}.cls-2{fill:#6c63ff;}.cls-3{fill:#2f2e41;}.cls-4{fill:#8985a8;}.cls-5{opacity:0.1;isolation:isolate;}.cls-6{fill:#f2f2f2;}.cls-7{fill:#ffb8b8;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 31") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 185.1,
    height: 99.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.46,
    y: 14.04,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39.01,
    y: 13.38,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41.95,
    y: 13.38,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41.95,
    y: 21.22,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 45.21,
    y: 17.3,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 45.21,
    y: 21.55,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41.95,
    y: 29.71,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 45.21,
    y: 33.95,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41.95,
    y: 49.95,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39.01,
    y: 33.95,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.46,
    y: 18.28,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.46,
    y: 59.09,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.46,
    y: 67.58,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.46,
    y: 71.82,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.81,
    y: 22.85,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41.62,
    y: 26.77,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.81,
    y: 43.74,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.81,
    y: 47.34,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41.62,
    y: 68.23,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39.01,
    y: 76.06,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "33.46 25.79 33.46 26.44 34.11 26.44 34.11 27.75 33.46 27.75 33.46 28.4 35.09 28.4 35.09 25.79 33.46 25.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "39.01 21.22 39.01 21.87 39.66 21.87 39.66 23.18 39.01 23.18 39.01 23.83 40.64 23.83 40.64 21.22 39.01 21.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "45.21 25.46 45.21 26.12 45.87 26.12 45.87 27.42 45.21 27.42 45.21 28.07 46.85 28.07 46.85 25.46 45.21 25.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "45.21 38.2 45.21 38.85 45.87 38.85 45.87 40.15 45.21 40.15 45.21 40.81 46.85 40.81 46.85 38.2 45.21 38.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "45.21 42.44 45.21 43.09 45.87 43.09 45.87 44.4 45.21 44.4 45.21 45.05 46.85 45.05 46.85 42.44 45.21 42.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "45.21 29.38 45.21 30.03 45.87 30.03 45.87 31.34 45.21 31.34 45.21 31.99 46.85 31.99 46.85 29.38 45.21 29.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "41.95 17.3 41.95 17.95 42.6 17.95 42.6 19.26 41.95 19.26 41.95 19.91 43.58 19.91 43.58 17.3 41.95 17.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41.95,
    y: 38.19,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41.95,
    y: 46.03,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "41.95 42.11 41.95 42.77 42.6 42.77 42.6 44.07 41.95 44.07 41.95 44.72 43.58 44.72 43.58 42.11 41.95 42.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "39.01 25.46 39.01 26.12 39.66 26.12 39.66 27.42 39.01 27.42 39.01 28.07 40.64 28.07 40.64 25.46 39.01 25.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "39.01 29.71 39.01 30.36 39.66 30.36 39.66 31.67 39.01 31.67 39.01 32.32 40.64 32.32 40.64 29.71 39.01 29.71"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39.01,
    y: 42.44,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "39.01 38.2 39.01 38.85 39.66 38.85 39.66 40.15 39.01 40.15 39.01 40.81 40.64 40.81 40.64 38.2 39.01 38.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39.01,
    y: 50.93,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "39.01 46.68 39.01 47.34 39.66 47.34 39.66 48.64 39.01 48.64 39.01 49.29 40.64 49.29 40.64 46.68 39.01 46.68"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39.01,
    y: 59.41,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41.95,
    y: 58.76,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "39.01 55.17 39.01 55.82 39.66 55.82 39.66 57.13 39.01 57.13 39.01 57.78 40.64 57.78 40.64 55.17 39.01 55.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "45.21 55.17 45.21 55.82 45.87 55.82 45.87 57.13 45.21 57.13 45.21 57.78 46.85 57.78 46.85 55.17 45.21 55.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 61.86,
    y: 17.3,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 61.86,
    y: 21.55,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 61.86,
    y: 33.95,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "61.86 25.46 61.86 26.12 62.52 26.12 62.52 27.42 61.86 27.42 61.86 28.07 63.49 28.07 63.49 25.46 61.86 25.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "61.86 38.2 61.86 38.85 62.52 38.85 62.52 40.15 61.86 40.15 61.86 40.81 63.49 40.81 63.49 38.2 61.86 38.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "61.86 42.44 61.86 43.09 62.52 43.09 62.52 44.4 61.86 44.4 61.86 45.05 63.49 45.05 63.49 42.44 61.86 42.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "61.86 29.38 61.86 30.03 62.52 30.03 62.52 31.34 61.86 31.34 61.86 31.99 63.49 31.99 63.49 29.38 61.86 29.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "61.86 55.17 61.86 55.82 62.52 55.82 62.52 57.13 61.86 57.13 61.86 57.78 63.49 57.78 63.49 55.17 61.86 55.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39.01,
    y: 67.9,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41.95,
    y: 63,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39.01,
    y: 79,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41.95,
    y: 71.17,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "39.01 63.66 39.01 64.31 39.66 64.31 39.66 65.62 39.01 65.62 39.01 66.27 40.64 66.27 40.64 63.66 39.01 63.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "39.01 83.57 39.01 84.22 39.66 84.22 39.66 85.53 39.01 85.53 39.01 86.18 40.64 86.18 40.64 83.57 39.01 83.57"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.97,
    y: 13.38,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.97,
    y: 33.95,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.97,
    y: 76.06,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56.97 21.22 56.97 21.87 57.62 21.87 57.62 23.18 56.97 23.18 56.97 23.83 58.6 23.83 58.6 21.22 56.97 21.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56.97 25.46 56.97 26.12 57.62 26.12 57.62 27.42 56.97 27.42 56.97 28.07 58.6 28.07 58.6 25.46 56.97 25.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56.97 29.71 56.97 30.36 57.62 30.36 57.62 31.67 56.97 31.67 56.97 32.32 58.6 32.32 58.6 29.71 56.97 29.71"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.97,
    y: 42.44,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56.97 38.2 56.97 38.85 57.62 38.85 57.62 40.15 56.97 40.15 56.97 40.81 58.6 40.81 58.6 38.2 56.97 38.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.97,
    y: 50.93,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56.97 46.68 56.97 47.34 57.62 47.34 57.62 48.64 56.97 48.64 56.97 49.29 58.6 49.29 58.6 46.68 56.97 46.68"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.97,
    y: 59.41,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56.97 55.17 56.97 55.82 57.62 55.82 57.62 57.13 56.97 57.13 56.97 57.78 58.6 57.78 58.6 55.17 56.97 55.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.97,
    y: 67.9,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.97,
    y: 79,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56.97 63.66 56.97 64.31 57.62 64.31 57.62 65.62 56.97 65.62 56.97 66.27 58.6 66.27 58.6 63.66 56.97 63.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56.97 83.57 56.97 84.22 57.62 84.22 57.62 85.53 56.97 85.53 56.97 86.18 58.6 86.18 58.6 83.57 56.97 83.57"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.8,
    y: 13.38,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.8,
    y: 33.95,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.8,
    y: 76.06,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.8 21.22 64.8 21.87 65.45 21.87 65.45 23.18 64.8 23.18 64.8 23.83 66.43 23.83 66.43 21.22 64.8 21.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.8 25.46 64.8 26.12 65.45 26.12 65.45 27.42 64.8 27.42 64.8 28.07 66.43 28.07 66.43 25.46 64.8 25.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.8 29.71 64.8 30.36 65.45 30.36 65.45 31.67 64.8 31.67 64.8 32.32 66.43 32.32 66.43 29.71 64.8 29.71"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.8,
    y: 42.44,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.8 38.2 64.8 38.85 65.45 38.85 65.45 40.15 64.8 40.15 64.8 40.81 66.43 40.81 66.43 38.2 64.8 38.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.8,
    y: 50.93,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.8 46.68 64.8 47.34 65.45 47.34 65.45 48.64 64.8 48.64 64.8 49.29 66.43 49.29 66.43 46.68 64.8 46.68"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.8,
    y: 59.41,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.8 55.17 64.8 55.82 65.45 55.82 65.45 57.13 64.8 57.13 64.8 57.78 66.43 57.78 66.43 55.17 64.8 55.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.8,
    y: 67.9,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.8,
    y: 79,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.8 63.66 64.8 64.31 65.45 64.31 65.45 65.62 64.8 65.62 64.8 66.27 66.43 66.27 66.43 63.66 64.8 63.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.8 83.57 64.8 84.22 65.45 84.22 65.45 85.53 64.8 85.53 64.8 86.18 66.43 86.18 66.43 83.57 64.8 83.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "41.95 79 41.95 79.65 42.6 79.65 42.6 80.96 41.95 80.96 41.95 81.61 43.58 81.61 43.58 79 41.95 79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "41.95 83.25 41.95 83.9 42.6 83.9 42.6 85.2 41.95 85.2 41.95 85.86 43.58 85.86 43.58 83.25 41.95 83.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "33.46 33.95 33.46 34.6 34.11 34.6 34.11 35.91 33.46 35.91 33.46 36.56 35.09 36.56 35.09 33.95 33.46 33.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "33.46 50.6 33.46 51.25 34.11 51.25 34.11 52.56 33.46 52.56 33.46 53.21 35.09 53.21 35.09 50.6 33.46 50.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "33.46 54.84 33.46 55.5 34.11 55.5 34.11 56.8 33.46 56.8 33.46 57.45 35.09 57.45 35.09 54.84 33.46 54.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "33.46 63.33 33.46 63.98 34.11 63.98 34.11 65.29 33.46 65.29 33.46 65.94 35.09 65.94 35.09 63.33 33.46 63.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "33.46 75.41 33.46 76.06 34.11 76.06 34.11 77.37 33.46 77.37 33.46 78.02 35.09 78.02 35.09 75.41 33.46 75.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "33.46 79 33.46 79.65 34.11 79.65 34.11 80.96 33.46 80.96 33.46 81.61 35.09 81.61 35.09 79 33.46 79"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 50.44,
    y: 14.04,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 50.44,
    y: 18.28,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.78,
    y: 22.85,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.78,
    y: 43.74,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.78,
    y: 47.34,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "50.44 25.79 50.44 26.44 51.09 26.44 51.09 27.75 50.44 27.75 50.44 28.4 52.07 28.4 52.07 25.79 50.44 25.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "50.44 33.95 50.44 34.6 51.09 34.6 51.09 35.91 50.44 35.91 50.44 36.56 52.07 36.56 52.07 33.95 50.44 33.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "50.44 50.6 50.44 51.25 51.09 51.25 51.09 52.56 50.44 52.56 50.44 53.21 52.07 53.21 52.07 50.6 50.44 50.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 69.04,
    y: 42.44,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 69.04,
    y: 46.68,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.39,
    y: 51.25,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.39,
    y: 72.15,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.39,
    y: 75.74,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "69.04 54.19 69.04 54.84 69.7 54.84 69.7 56.15 69.04 56.15 69.04 56.8 70.68 56.8 70.68 54.19 69.04 54.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "69.04 62.35 69.04 63.01 69.7 63.01 69.7 64.31 69.04 64.31 69.04 64.96 70.68 64.96 70.68 62.35 69.04 62.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "69.04 79 69.04 79.65 69.7 79.65 69.7 80.96 69.04 80.96 69.04 81.61 70.68 81.61 70.68 79 69.04 79"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 74.27,
    y: 14.04,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 79.82,
    y: 13.38,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 82.75,
    y: 13.38,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 82.75,
    y: 21.22,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 86.02,
    y: 17.3,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 86.02,
    y: 21.55,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 82.75,
    y: 29.71,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 86.02,
    y: 33.95,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 82.75,
    y: 49.95,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 79.82,
    y: 33.95,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 74.27,
    y: 18.28,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 74.27,
    y: 59.09,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 74.27,
    y: 67.58,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 74.27,
    y: 71.82,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 73.61,
    y: 22.85,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 82.43,
    y: 26.77,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 73.61,
    y: 43.74,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 73.61,
    y: 47.34,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 82.43,
    y: 68.23,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 79.82,
    y: 76.06,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "74.27 25.79 74.27 26.44 74.92 26.44 74.92 27.75 74.27 27.75 74.27 28.4 75.9 28.4 75.9 25.79 74.27 25.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "79.82 21.22 79.82 21.87 80.47 21.87 80.47 23.18 79.82 23.18 79.82 23.83 81.45 23.83 81.45 21.22 79.82 21.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "86.02 25.46 86.02 26.12 86.67 26.12 86.67 27.42 86.02 27.42 86.02 28.07 87.65 28.07 87.65 25.46 86.02 25.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "86.02 38.2 86.02 38.85 86.67 38.85 86.67 40.15 86.02 40.15 86.02 40.81 87.65 40.81 87.65 38.2 86.02 38.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "86.02 42.44 86.02 43.09 86.67 43.09 86.67 44.4 86.02 44.4 86.02 45.05 87.65 45.05 87.65 42.44 86.02 42.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "86.02 29.38 86.02 30.03 86.67 30.03 86.67 31.34 86.02 31.34 86.02 31.99 87.65 31.99 87.65 29.38 86.02 29.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "82.75 17.3 82.75 17.95 83.41 17.95 83.41 19.26 82.75 19.26 82.75 19.91 84.39 19.91 84.39 17.3 82.75 17.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 82.75,
    y: 38.19,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 82.75,
    y: 46.03,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "82.75 42.11 82.75 42.77 83.41 42.77 83.41 44.07 82.75 44.07 82.75 44.72 84.39 44.72 84.39 42.11 82.75 42.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "79.82 25.46 79.82 26.12 80.47 26.12 80.47 27.42 79.82 27.42 79.82 28.07 81.45 28.07 81.45 25.46 79.82 25.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "79.82 29.71 79.82 30.36 80.47 30.36 80.47 31.67 79.82 31.67 79.82 32.32 81.45 32.32 81.45 29.71 79.82 29.71"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 79.82,
    y: 42.44,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "79.82 38.2 79.82 38.85 80.47 38.85 80.47 40.15 79.82 40.15 79.82 40.81 81.45 40.81 81.45 38.2 79.82 38.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 79.82,
    y: 50.93,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "79.82 46.68 79.82 47.34 80.47 47.34 80.47 48.64 79.82 48.64 79.82 49.29 81.45 49.29 81.45 46.68 79.82 46.68"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 79.82,
    y: 59.41,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 82.75,
    y: 58.76,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "79.82 55.17 79.82 55.82 80.47 55.82 80.47 57.13 79.82 57.13 79.82 57.78 81.45 57.78 81.45 55.17 79.82 55.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "86.02 55.17 86.02 55.82 86.67 55.82 86.67 57.13 86.02 57.13 86.02 57.78 87.65 57.78 87.65 55.17 86.02 55.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 102.67,
    y: 17.3,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 102.67,
    y: 21.55,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 102.67,
    y: 33.95,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "102.67 25.46 102.67 26.12 103.32 26.12 103.32 27.42 102.67 27.42 102.67 28.07 104.3 28.07 104.3 25.46 102.67 25.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "102.67 38.2 102.67 38.85 103.32 38.85 103.32 40.15 102.67 40.15 102.67 40.81 104.3 40.81 104.3 38.2 102.67 38.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "102.67 42.44 102.67 43.09 103.32 43.09 103.32 44.4 102.67 44.4 102.67 45.05 104.3 45.05 104.3 42.44 102.67 42.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "102.67 29.38 102.67 30.03 103.32 30.03 103.32 31.34 102.67 31.34 102.67 31.99 104.3 31.99 104.3 29.38 102.67 29.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "102.67 55.17 102.67 55.82 103.32 55.82 103.32 57.13 102.67 57.13 102.67 57.78 104.3 57.78 104.3 55.17 102.67 55.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 79.82,
    y: 67.9,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 82.75,
    y: 63,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 79.82,
    y: 79,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 82.75,
    y: 71.17,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "79.82 63.66 79.82 64.31 80.47 64.31 80.47 65.62 79.82 65.62 79.82 66.27 81.45 66.27 81.45 63.66 79.82 63.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "79.82 83.57 79.82 84.22 80.47 84.22 80.47 85.53 79.82 85.53 79.82 86.18 81.45 86.18 81.45 83.57 79.82 83.57"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.77,
    y: 13.38,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.77,
    y: 33.95,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.77,
    y: 76.06,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "97.77 21.22 97.77 21.87 98.42 21.87 98.42 23.18 97.77 23.18 97.77 23.83 99.4 23.83 99.4 21.22 97.77 21.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "97.77 25.46 97.77 26.12 98.42 26.12 98.42 27.42 97.77 27.42 97.77 28.07 99.4 28.07 99.4 25.46 97.77 25.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "97.77 29.71 97.77 30.36 98.42 30.36 98.42 31.67 97.77 31.67 97.77 32.32 99.4 32.32 99.4 29.71 97.77 29.71"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.77,
    y: 42.44,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "97.77 38.2 97.77 38.85 98.42 38.85 98.42 40.15 97.77 40.15 97.77 40.81 99.4 40.81 99.4 38.2 97.77 38.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.77,
    y: 50.93,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "97.77 46.68 97.77 47.34 98.42 47.34 98.42 48.64 97.77 48.64 97.77 49.29 99.4 49.29 99.4 46.68 97.77 46.68"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.77,
    y: 59.41,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "97.77 55.17 97.77 55.82 98.42 55.82 98.42 57.13 97.77 57.13 97.77 57.78 99.4 57.78 99.4 55.17 97.77 55.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.77,
    y: 67.9,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.77,
    y: 79,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "97.77 63.66 97.77 64.31 98.42 64.31 98.42 65.62 97.77 65.62 97.77 66.27 99.4 66.27 99.4 63.66 97.77 63.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "97.77 83.57 97.77 84.22 98.42 84.22 98.42 85.53 97.77 85.53 97.77 86.18 99.4 86.18 99.4 83.57 97.77 83.57"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 105.61,
    y: 13.38,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 105.61,
    y: 33.95,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 105.61,
    y: 76.06,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "105.61 21.22 105.61 21.87 106.26 21.87 106.26 23.18 105.61 23.18 105.61 23.83 107.24 23.83 107.24 21.22 105.61 21.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "105.61 25.46 105.61 26.12 106.26 26.12 106.26 27.42 105.61 27.42 105.61 28.07 107.24 28.07 107.24 25.46 105.61 25.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "105.61 29.71 105.61 30.36 106.26 30.36 106.26 31.67 105.61 31.67 105.61 32.32 107.24 32.32 107.24 29.71 105.61 29.71"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 105.61,
    y: 42.44,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "105.61 38.2 105.61 38.85 106.26 38.85 106.26 40.15 105.61 40.15 105.61 40.81 107.24 40.81 107.24 38.2 105.61 38.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 105.61,
    y: 50.93,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "105.61 46.68 105.61 47.34 106.26 47.34 106.26 48.64 105.61 48.64 105.61 49.29 107.24 49.29 107.24 46.68 105.61 46.68"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 105.61,
    y: 59.41,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "105.61 55.17 105.61 55.82 106.26 55.82 106.26 57.13 105.61 57.13 105.61 57.78 107.24 57.78 107.24 55.17 105.61 55.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 105.61,
    y: 67.9,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 105.61,
    y: 79,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "105.61 63.66 105.61 64.31 106.26 64.31 106.26 65.62 105.61 65.62 105.61 66.27 107.24 66.27 107.24 63.66 105.61 63.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "105.61 83.57 105.61 84.22 106.26 84.22 106.26 85.53 105.61 85.53 105.61 86.18 107.24 86.18 107.24 83.57 105.61 83.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "82.75 79 82.75 79.65 83.41 79.65 83.41 80.96 82.75 80.96 82.75 81.61 84.39 81.61 84.39 79 82.75 79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "82.75 83.25 82.75 83.9 83.41 83.9 83.41 85.2 82.75 85.2 82.75 85.86 84.39 85.86 84.39 83.25 82.75 83.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "74.27 33.95 74.27 34.6 74.92 34.6 74.92 35.91 74.27 35.91 74.27 36.56 75.9 36.56 75.9 33.95 74.27 33.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "74.27 50.6 74.27 51.25 74.92 51.25 74.92 52.56 74.27 52.56 74.27 53.21 75.9 53.21 75.9 50.6 74.27 50.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "74.27 54.84 74.27 55.5 74.92 55.5 74.92 56.8 74.27 56.8 74.27 57.45 75.9 57.45 75.9 54.84 74.27 54.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "74.27 63.33 74.27 63.98 74.92 63.98 74.92 65.29 74.27 65.29 74.27 65.94 75.9 65.94 75.9 63.33 74.27 63.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "74.27 75.41 74.27 76.06 74.92 76.06 74.92 77.37 74.27 77.37 74.27 78.02 75.9 78.02 75.9 75.41 74.27 75.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "74.27 79 74.27 79.65 74.92 79.65 74.92 80.96 74.27 80.96 74.27 81.61 75.9 81.61 75.9 79 74.27 79"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 91.24,
    y: 14.04,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 91.24,
    y: 18.28,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 90.59,
    y: 22.85,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 90.59,
    y: 43.74,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 90.59,
    y: 47.34,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "91.24 25.79 91.24 26.44 91.9 26.44 91.9 27.75 91.24 27.75 91.24 28.4 92.88 28.4 92.88 25.79 91.24 25.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "91.24 33.95 91.24 34.6 91.9 34.6 91.9 35.91 91.24 35.91 91.24 36.56 92.88 36.56 92.88 33.95 91.24 33.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "91.24 50.6 91.24 51.25 91.9 51.25 91.9 52.56 91.24 52.56 91.24 53.21 92.88 53.21 92.88 50.6 91.24 50.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 109.85,
    y: 42.44,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 109.85,
    y: 46.68,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 109.2,
    y: 51.25,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 109.2,
    y: 72.15,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 109.2,
    y: 75.74,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "109.85 54.19 109.85 54.84 110.5 54.84 110.5 56.15 109.85 56.15 109.85 56.8 111.48 56.8 111.48 54.19 109.85 54.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "109.85 62.35 109.85 63.01 110.5 63.01 110.5 64.31 109.85 64.31 109.85 64.96 111.48 64.96 111.48 62.35 109.85 62.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "109.85 79 109.85 79.65 110.5 79.65 110.5 80.96 109.85 80.96 109.85 81.61 111.48 81.61 111.48 79 109.85 79"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 115.07,
    y: 14.04,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.62,
    y: 13.38,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.56,
    y: 13.38,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.56,
    y: 21.22,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 126.83,
    y: 17.3,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 126.83,
    y: 21.55,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.56,
    y: 29.71,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 126.83,
    y: 33.95,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.56,
    y: 49.95,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.62,
    y: 33.95,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 115.07,
    y: 18.28,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 115.07,
    y: 59.09,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 115.07,
    y: 67.58,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 115.07,
    y: 71.82,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 114.42,
    y: 22.85,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.23,
    y: 26.77,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 114.42,
    y: 43.74,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 114.42,
    y: 47.34,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.23,
    y: 68.23,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.62,
    y: 76.06,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.07 25.79 115.07 26.44 115.73 26.44 115.73 27.75 115.07 27.75 115.07 28.4 116.71 28.4 116.71 25.79 115.07 25.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "120.62 21.22 120.62 21.87 121.28 21.87 121.28 23.18 120.62 23.18 120.62 23.83 122.25 23.83 122.25 21.22 120.62 21.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "126.83 25.46 126.83 26.12 127.48 26.12 127.48 27.42 126.83 27.42 126.83 28.07 128.46 28.07 128.46 25.46 126.83 25.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "126.83 38.2 126.83 38.85 127.48 38.85 127.48 40.15 126.83 40.15 126.83 40.81 128.46 40.81 128.46 38.2 126.83 38.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "126.83 42.44 126.83 43.09 127.48 43.09 127.48 44.4 126.83 44.4 126.83 45.05 128.46 45.05 128.46 42.44 126.83 42.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "126.83 29.38 126.83 30.03 127.48 30.03 127.48 31.34 126.83 31.34 126.83 31.99 128.46 31.99 128.46 29.38 126.83 29.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "123.56 17.3 123.56 17.95 124.21 17.95 124.21 19.26 123.56 19.26 123.56 19.91 125.19 19.91 125.19 17.3 123.56 17.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.56,
    y: 38.19,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.56,
    y: 46.03,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "123.56 42.11 123.56 42.77 124.21 42.77 124.21 44.07 123.56 44.07 123.56 44.72 125.19 44.72 125.19 42.11 123.56 42.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "120.62 25.46 120.62 26.12 121.28 26.12 121.28 27.42 120.62 27.42 120.62 28.07 122.25 28.07 122.25 25.46 120.62 25.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "120.62 29.71 120.62 30.36 121.28 30.36 121.28 31.67 120.62 31.67 120.62 32.32 122.25 32.32 122.25 29.71 120.62 29.71"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.62,
    y: 42.44,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "120.62 38.2 120.62 38.85 121.28 38.85 121.28 40.15 120.62 40.15 120.62 40.81 122.25 40.81 122.25 38.2 120.62 38.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.62,
    y: 50.93,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "120.62 46.68 120.62 47.34 121.28 47.34 121.28 48.64 120.62 48.64 120.62 49.29 122.25 49.29 122.25 46.68 120.62 46.68"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.62,
    y: 59.41,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.56,
    y: 58.76,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "120.62 55.17 120.62 55.82 121.28 55.82 121.28 57.13 120.62 57.13 120.62 57.78 122.25 57.78 122.25 55.17 120.62 55.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "126.83 55.17 126.83 55.82 127.48 55.82 127.48 57.13 126.83 57.13 126.83 57.78 128.46 57.78 128.46 55.17 126.83 55.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 143.47,
    y: 17.3,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 143.47,
    y: 21.55,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 143.47,
    y: 33.95,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.47 25.46 143.47 26.12 144.13 26.12 144.13 27.42 143.47 27.42 143.47 28.07 145.11 28.07 145.11 25.46 143.47 25.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.47 38.2 143.47 38.85 144.13 38.85 144.13 40.15 143.47 40.15 143.47 40.81 145.11 40.81 145.11 38.2 143.47 38.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.47 42.44 143.47 43.09 144.13 43.09 144.13 44.4 143.47 44.4 143.47 45.05 145.11 45.05 145.11 42.44 143.47 42.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.47 29.38 143.47 30.03 144.13 30.03 144.13 31.34 143.47 31.34 143.47 31.99 145.11 31.99 145.11 29.38 143.47 29.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.47 55.17 143.47 55.82 144.13 55.82 144.13 57.13 143.47 57.13 143.47 57.78 145.11 57.78 145.11 55.17 143.47 55.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.62,
    y: 67.9,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.56,
    y: 63,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.62,
    y: 79,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.56,
    y: 71.17,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "120.62 63.66 120.62 64.31 121.28 64.31 121.28 65.62 120.62 65.62 120.62 66.27 122.25 66.27 122.25 63.66 120.62 63.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "120.62 83.57 120.62 84.22 121.28 84.22 121.28 85.53 120.62 85.53 120.62 86.18 122.25 86.18 122.25 83.57 120.62 83.57"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 138.58,
    y: 13.38,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 138.58,
    y: 33.95,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 138.58,
    y: 76.06,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.58 21.22 138.58 21.87 139.23 21.87 139.23 23.18 138.58 23.18 138.58 23.83 140.21 23.83 140.21 21.22 138.58 21.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.58 25.46 138.58 26.12 139.23 26.12 139.23 27.42 138.58 27.42 138.58 28.07 140.21 28.07 140.21 25.46 138.58 25.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.58 29.71 138.58 30.36 139.23 30.36 139.23 31.67 138.58 31.67 138.58 32.32 140.21 32.32 140.21 29.71 138.58 29.71"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 138.58,
    y: 42.44,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.58 38.2 138.58 38.85 139.23 38.85 139.23 40.15 138.58 40.15 138.58 40.81 140.21 40.81 140.21 38.2 138.58 38.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 138.58,
    y: 50.93,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.58 46.68 138.58 47.34 139.23 47.34 139.23 48.64 138.58 48.64 138.58 49.29 140.21 49.29 140.21 46.68 138.58 46.68"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 138.58,
    y: 59.41,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.58 55.17 138.58 55.82 139.23 55.82 139.23 57.13 138.58 57.13 138.58 57.78 140.21 57.78 140.21 55.17 138.58 55.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 138.58,
    y: 67.9,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 138.58,
    y: 79,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.58 63.66 138.58 64.31 139.23 64.31 139.23 65.62 138.58 65.62 138.58 66.27 140.21 66.27 140.21 63.66 138.58 63.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.58 83.57 138.58 84.22 139.23 84.22 139.23 85.53 138.58 85.53 138.58 86.18 140.21 86.18 140.21 83.57 138.58 83.57"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 146.41,
    y: 13.38,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 146.41,
    y: 33.95,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 146.41,
    y: 76.06,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "146.41 21.22 146.41 21.87 147.06 21.87 147.06 23.18 146.41 23.18 146.41 23.83 148.04 23.83 148.04 21.22 146.41 21.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "146.41 25.46 146.41 26.12 147.06 26.12 147.06 27.42 146.41 27.42 146.41 28.07 148.04 28.07 148.04 25.46 146.41 25.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "146.41 29.71 146.41 30.36 147.06 30.36 147.06 31.67 146.41 31.67 146.41 32.32 148.04 32.32 148.04 29.71 146.41 29.71"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 146.41,
    y: 42.44,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "146.41 38.2 146.41 38.85 147.06 38.85 147.06 40.15 146.41 40.15 146.41 40.81 148.04 40.81 148.04 38.2 146.41 38.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 146.41,
    y: 50.93,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "146.41 46.68 146.41 47.34 147.06 47.34 147.06 48.64 146.41 48.64 146.41 49.29 148.04 49.29 148.04 46.68 146.41 46.68"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 146.41,
    y: 59.41,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "146.41 55.17 146.41 55.82 147.06 55.82 147.06 57.13 146.41 57.13 146.41 57.78 148.04 57.78 148.04 55.17 146.41 55.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 146.41,
    y: 67.9,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 146.41,
    y: 79,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "146.41 63.66 146.41 64.31 147.06 64.31 147.06 65.62 146.41 65.62 146.41 66.27 148.04 66.27 148.04 63.66 146.41 63.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "146.41 83.57 146.41 84.22 147.06 84.22 147.06 85.53 146.41 85.53 146.41 86.18 148.04 86.18 148.04 83.57 146.41 83.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "123.56 79 123.56 79.65 124.21 79.65 124.21 80.96 123.56 80.96 123.56 81.61 125.19 81.61 125.19 79 123.56 79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "123.56 83.25 123.56 83.9 124.21 83.9 124.21 85.2 123.56 85.2 123.56 85.86 125.19 85.86 125.19 83.25 123.56 83.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.07 33.95 115.07 34.6 115.73 34.6 115.73 35.91 115.07 35.91 115.07 36.56 116.71 36.56 116.71 33.95 115.07 33.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.07 50.6 115.07 51.25 115.73 51.25 115.73 52.56 115.07 52.56 115.07 53.21 116.71 53.21 116.71 50.6 115.07 50.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.07 54.84 115.07 55.5 115.73 55.5 115.73 56.8 115.07 56.8 115.07 57.45 116.71 57.45 116.71 54.84 115.07 54.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.07 63.33 115.07 63.98 115.73 63.98 115.73 65.29 115.07 65.29 115.07 65.94 116.71 65.94 116.71 63.33 115.07 63.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.07 75.41 115.07 76.06 115.73 76.06 115.73 77.37 115.07 77.37 115.07 78.02 116.71 78.02 116.71 75.41 115.07 75.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.07 79 115.07 79.65 115.73 79.65 115.73 80.96 115.07 80.96 115.07 81.61 116.71 81.61 116.71 79 115.07 79"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 132.05,
    y: 14.04,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 132.05,
    y: 18.28,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 131.4,
    y: 22.85,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 131.4,
    y: 43.74,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 131.4,
    y: 47.34,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "132.05 25.79 132.05 26.44 132.7 26.44 132.7 27.75 132.05 27.75 132.05 28.4 133.68 28.4 133.68 25.79 132.05 25.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "132.05 33.95 132.05 34.6 132.7 34.6 132.7 35.91 132.05 35.91 132.05 36.56 133.68 36.56 133.68 33.95 132.05 33.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "132.05 50.6 132.05 51.25 132.7 51.25 132.7 52.56 132.05 52.56 132.05 53.21 133.68 53.21 133.68 50.6 132.05 50.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 150.66,
    y: 42.44,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 150.66,
    y: 46.68,
    width: 1.63,
    height: 2.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 150,
    y: 51.25,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 150,
    y: 72.15,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 150,
    y: 75.74,
    width: 2.29,
    height: 0.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "150.66 54.19 150.66 54.84 151.31 54.84 151.31 56.15 150.66 56.15 150.66 56.8 152.29 56.8 152.29 54.19 150.66 54.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "150.66 62.35 150.66 63.01 151.31 63.01 151.31 64.31 150.66 64.31 150.66 64.96 152.29 64.96 152.29 62.35 150.66 62.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "150.66 79 150.66 79.65 151.31 79.65 151.31 80.96 150.66 80.96 150.66 81.61 152.29 81.61 152.29 79 150.66 79"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 45.36,
    y: 149.46,
    width: 175.07,
    height: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.55,85.53v11L83,103.3a46.28,46.28,0,0,0,0,5.5c.21,1.27-.21,3.38-1.48,3.38s-1.9,3.17-1.9,3.17-.42,1.27-1.48,1.48-1.06,0-1.06,0L76.26,119,58.7,130.59l3.38,8.46s5.29-1.9,5.71-2.54,4,.85,4-.63.63-5.29,1.9-5.5,11.85-5.08,11.85-5.08,5.5-6.13,5.92-8.46S93.82,108,93.82,108l5.29,8.88v17.77l-.85,9.52,9.31-1.27s-.85-5.92,0-6.77,2.12-11,1.27-12.27.42-7,0-7.83-.21-7-1.27-8.67-7.4-19-7.4-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.53,143.71s-3.17,5.29-1.06,5.92,6.13,0,6.56,0,8,.21,8,.21,5.08-1.06,5.08-2.54-3.17-1.48-4.23-1.69-7.62-2.75-7.62-2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M59.67,130.83s-6.11-.81-5.86,1.38,2.44,5.63,2.61,6,1.45,3.59,2.3,5.71a12.37,12.37,0,0,0,2.72,4.16c.83.83,1.74,1.5,2.33,1.24,1.36-.59.1-3.5-.13-4.55s-.5-8.08-.5-8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M102.17,50.52l6.77-15.65a2.11,2.11,0,0,0-2.12-1.27s-2-5.18-5.82-5.18c0,0-5.71-3.17-7.4,0,0,0-3.6,3.17-3.38,6.13s.42,5.08.42,5.08-3.38.42-2.75,2.12.85,1.69,0,2.33l-.85.63S69.49,60.57,79.22,83.84l.85,3.6v3.38s21.37.21,21.37,0a2.59,2.59,0,0,1,.42-2.33,3.3,3.3,0,0,0,.85-2.12s-.85-4.23-.42-5.5.63-6.77-.21-8-.42-11.42-.42-11.42l1.9-3.6-.63-2.12-.63-2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M100.38,92.94S97.84,86,98,84.69a13.22,13.22,0,0,0-.42-3.81l-.85-17.13s3.6-15.23-4.44-17.77a9.12,9.12,0,0,0-3.7,3.74C87,50.45,85,52.31,84.51,57c-.85,8.25,3,29.4,4.87,33s3.17,6.13,3.17,6.13l2-.88.13.25Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 101.54,
    cy: 47.99,
    r: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 101.33,
    y: 47.99,
    width: 0.42,
    height: 9.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M93.92,93.68l1.69,3.6s3.81-1.27,3.81-1.9S97.73,92,97.73,92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.49,46s-4.87,2.12-5.71,10.37,3,29.4,4.87,33,3.17,6.13,3.17,6.13l5.71-2.54S97,86,97.2,84.69a13.22,13.22,0,0,0-.42-3.81l-.85-17.13S99.53,48.51,91.49,46Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGfxHacker);
export default __webpack_public_path__ + "static/media/gfx-hacker.e1358f4c8d8b60e86234ac447b3bf9d5.svg";
export { ForwardRef as ReactComponent };